import PropTypes from 'prop-types';
import React from 'react';

import { CHART_TYPES } from '_constants/charts';

import Line from './Line';

const view = {
  [CHART_TYPES.line]: Line,
};

const Chart = ({ type, ...restProps }) => {
  const View = view[type];

  if (!View) {
    return null;
  }

  return <View {...restProps} />;
};

Chart.propTypes = {
  type: PropTypes.oneOf([CHART_TYPES.line]),
};

export default Chart;
